import * as React from "react"
import { Route } from "react-router-dom"
import { NavLink } from "react-router-dom/cjs/react-router-dom.min";
import Logo from './imgs/logos/logo.png';
import './App.css';

export const HeaderLayout = ({ component: Component, ...rest }) => {
    const [isNavOpen, setNav] = React.useState(false);

    const onToggle = () => {
        setNav(!isNavOpen);
    };

    const closeToggle = () => {
        setNav(false);
    };
    return (
        <Route {...rest} render={(props) => (
            <>
                <div className={'sticky'}>
                    {/* <div className="headerFloral">We are closed for 2024 inquiries, now booking 2025 events!
</div> */}
                    <div className='logo_header'>
                        <a href='/'>
                            <img id='header_img' alt='logo' src={Logo} />
                        </a>
                        <nav className="navbar navbar-expand-lg navbar-light">
                            <button className="navbar-toggler" type="button" data-toggle="collapse" aria-expanded="false" aria-label="Toggle navigation" onClick={onToggle} >
                                <span className="navbar-toggler-icon"></span>
                            </button>
                            <div className="collapse navbar-collapse" id="navbarNavAltMarkup">
                                <div onClick={closeToggle} className="navbar-nav">
                                    {/* <NavLink className="nav-item nav-link" to='/' exact={true}>Home</NavLink>
                                <NavLink className="nav-item nav-link" to='/gallery'>Gallery</NavLink>
                                <NavLink className="nav-item nav-link" to='/about'>About</NavLink>
                                <NavLink className="nav-item nav-link" to='/contact'>Contact</NavLink> */}
                                    <a className="nav-item nav-link" href='/#home' exact={'true'}>Home</a>
                                    {/* <a className="nav-item nav-link" href='#gallery'>Services</a> */}

                                    <a className="nav-item nav-link" href='/#about'>About</a>
                                    <a className="nav-item nav-link" href='/#contact'>Contact</a>
                                    <li className="nav-item dropdown">
                                        <a className="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                            Services
                                        </a>
                                        <div className="dropdown-menu" aria-labelledby="navbarDropdown">
                                            <a className="dropdown-item" href="/doc">Day of Coordination</a>
                                            <a className="dropdown-item" href="/planning">Planning & Design</a>
                                            <a className="dropdown-item" href="/florals">Florals</a>
                                        </div>
                                    </li>
                                </div>
                            </div>
                            {isNavOpen &&
                                <div id="mySidenav" onClick={closeToggle} className="sidenav">
                                    <div onClick={closeToggle} className="sidenav-items">
                                        {/* <NavLink className="nav-item nav-link" to='/' exact={true}>Home</NavLink>
                                    <NavLink className="nav-item nav-link" to='/gallery'>Gallery</NavLink>
                                    <NavLink className="nav-item nav-link" to='/about'>About</NavLink>
                                    <NavLink className="nav-item nav-link" to='/contact'>Contact</NavLink> */}
                                        <a className="nav-item nav-link" href='/#home' exact={'true'}>Home</a>
                                        <a className="nav-item nav-link" href='/#about'>About</a>
                                        <a className="nav-item nav-link" href='/#contact'>Contact</a>
                                        <br></br>
                                        <a className="nav-item nav-link" href='/doc'>Day of Coordination</a>
                                        <a className="nav-item nav-link" href='/planning'>Planning & Design</a>
                                        <a className="nav-item nav-link" href='/florals'>Florals</a>
                                    </div>
                                </div>
                            }
                        </nav>
                    </div>
                </div>
                <Component {...props} />
                <footer className="section section_footer">
                    <div className="footcontainer">
                        <div className="icons">
                            <a href="https://www.facebook.com/blissfullyso/" target='_blank'>
                                <img src="https://assets-global.website-files.com/5babb9f91ab233724e53ce0b/5babb9f91ab233460253ce65_font-awesome_4-7-0_facebook_100_0_278bd5_none.png"
                                    width="25" alt="fb" />
                            </a>
                            <a href="https://www.instagram.com/blissfullyso.events" target='_blank'>
                                <img src="https://assets-global.website-files.com/5babb9f91ab233724e53ce0b/5babb9f91ab233817a53ce66_font-awesome_4-7-0_instagram_100_0_278bd5_none.png"
                                    width="25" alt="insta" />
                            </a>
                        </div>
                        <h5>NJ . NY // 917.830.7788</h5>
                        <h5>BLISSFULLYSOEVENTS@GMAIL.COM</h5>
                        <h6>DESIGN/BRANDING: ARIEL MA</h6>
                        <h6>www.arielma.com</h6>
                    </div>
                </footer>
            </>
        )} />
    )
};
